class Spinner extends HTMLElement {
    width = "1.8rem";
    height = "1.8rem";
    borderWidth = "0.25em";
    speed = 800;

    constructor() {
        super();
        const shadow = this.attachShadow({mode: 'open'});
        const spinnerElement = document.createElement('div');
        spinnerElement.className = 'gnd-spinner';
        const style = document.createElement("style");
        style.textContent = `
        :host {
          box-sizing: border-box;
          display: inline-block;
          width: ${this.width};
          height: ${this.height};
          vertical-align: middle;
          border-radius: 50%;
          animation: ${this.speed}ms linear infinite spinner-anime;
          border: ${this.borderWidth} solid black;
          border-right-color: transparent;
        }

        @keyframes spinner-anime {
          100% {
            transform: rotate(360deg);
          }
        }
        `;
        shadow.append(style, spinnerElement);
    }

    static define(tag) {
        try {
            customElements.define(tag, this);
        } catch (err) {
            throw new Error(`Couldn't define ${tag} element`);
        }
    }
}

export default function defineSpinnerElement() {
    Spinner.define('gnd-spinner');
}
